<div class="modal-header">
  <h4 class="modal-title">
    {{'projectRequestPopup.title' | translate}}
  </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <p>{{'projectRequestPopup.label.multiple_quote' | translate}}</p>
    <div class="ps-5">
      <div class="form-check">
        <input class="form-check-input" [disabled]="currentProjectIsRequested" type="radio" name="gridRadios" id="gridRadios1" [value]="types[0]" [(ngModel)]="selectedQuoteType">
        <label class="form-check-label" for="gridRadios1">{{ 'projectRequestPopup.label.multiple_quote.type.current' | translate }}</label>
      </div>
      <div class="form-check mt-3">
        <input class="form-check-input" type="radio" name="gridRadios" id="gridRadios2" [value]="types[1]" [(ngModel)]="selectedQuoteType">
        <label class="form-check-label" for="gridRadios2">{{ 'projectRequestPopup.label.multiple_quote.type.saved' | translate }}</label>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary btn-cancel" (click)="close()">{{'global.label.close' | translate}}</button>
  <button type="submit" class="btn btn-primary btn-forward" data-testid="request-order-quote-type-confirm" (click)="next()">{{'global.label.step_forward' | translate}}</button>
</div>
